import { render, staticRenderFns } from "./AreasForAttachingText.vue?vue&type=template&id=0a6f502b&scoped=true&"
import script from "./AreasForAttachingText.vue?vue&type=script&lang=ts&"
export * from "./AreasForAttachingText.vue?vue&type=script&lang=ts&"
import style0 from "./AreasForAttachingText.vue?vue&type=style&index=0&id=0a6f502b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f502b",
  null
  
)

export default component.exports